<template>
  <div id="guests" class="page">
    <h1>Gästeliste</h1>    
    <div id="foto_container">
      <div id="foto">
        <img src="../assets/img/ben-2018.jpeg">
      </div>
      <div id="kidsname">
          <p>{{party.kidsname}}</p>
      </div>
    </div>
    <div  id="whoareyou">
      <h3 v-if="!$store.state.userfacts.kid">Bitte sag uns noch, wer Du bist ...</h3>
    </div>
    <div id="guestsbox">
      <ul>
        <li v-for="(guest,key) in party.guests">
          <div :class=" 'guest ' + ( guest.comes === false ? 'comesnot':'' ) ">
            <div class="guest_image" >
              <div class="guest_image_container">
                <img v-if=" guest.image != ''" :src="guest.image">
              </div>
              <div class="guest_name">
                {{ guest.surname }} 
              </div>
              <div class="guest_from">
                aus {{ guest.city}} 
               </div>
            </div>
            <div class="guest_content">  
              <div class="ooo">                          
                <div class="comes"><a v-if=" guest.comes === true ">ist dabei</a></div>
                <div class="comesnot"><a v-if=" guest.comes === false ">kann nicht</a></div>
<!--                 <a v-if=" !guest.comes">?</a> -->
                <div v-if=" key == $store.state.userfacts.kid ">( Das seid ihr! )<br><a class="button" v-on:click="thatsUs(key)">bearbeiten</a></div>
                
                <div><a v-on:click="thatsUs(key)" class="button" v-if=" !$store.state.userfacts.kid  && !guest.thatsus ">Das sind wir</a></div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div id="sum_guests_container" v-if="party.guests">
      <div id="sum_guests">{{ filterComing() }} / {{ Object.keys(party.guests).length  }} sind dabei</div>
    </div>

  </div>
</template>
<script>
import {db} from '../service/firebase';  
export default {
  name: 'Guests',
  components: {
    
  },
  firebase: {},
  data (){
    return {
      party: {
        guests:[]
      },
    }
  },
  mounted() {
    //console.log( this.$store.state.currentParty )
  },
  created (){
   this.$bindAsObject('party', db.ref('parties/' + this.$store.state.currentParty), null, function() { /* console.log('Ready fired!') */ } );
  },
  methods: {
    filterComing(){
      //console.log('filter');
      var coming = 0;
      let self = this;
      Object.keys(this.party.guests).forEach(function(guest){ 
        self.party.guests[guest].comes === true && coming++;
        //console.log( self.party.guests[guest].comes === true && coming++ );
        //console.log( coming );
      });
      return coming;
    },
    thatsUs(key){
      //console.log('that`s us');
      this.$store.state.userfacts.kid = key;
      this.$cookie.set('party', JSON.stringify(this.$store.state.userfacts), 30);  
      
      if( this.$store.state.userfacts.gift ) {
        
        this.$store.state.userfacts.kid = key;
       this.$cookie.set('party', JSON.stringify(this.$store.state.userfacts), 30); 
       
        var updates = {};
        updates['/parties/' + this.$store.state.currentParty + '/wishes/' + this.$store.state.userfacts.gift  +'/taken' ] = key;
        var ref =  db.ref().update(updates)
      }
      
      this.$router.push('/guests/guest/thatsus' )
        
//      party.guests   
    }
/*
    chooseGift(key) {
      //console.log( this.$store.state );
      //var cookieee = JSON.stringify({ 'currentParty': this.$store.state.currentParty, 'kid': null, 'gift': key })
       

      this.$store.state.userfacts.gift = key;
      this.$cookie.set('party', JSON.stringify(this.$store.state.userfacts), 30); 
      
      this.$router.push('/wishlist/wish/selected' )

      
      //console.log( this.$store.state.userfacts );


      var updates = {};
      updates['/party/' + this.$store.state.currentParty + '/wishes/' + key ] = {};
      var ref =  db.ref().update(updates)
      
    }
*/
  }
  
}

</script>
<style>
/*   #guests { padding-bottom: 5.4333333em; } */
  #whoareyou { padding: 1.43333333em 0; }
  #whoareyou h3 { color: #dc1200; padding: 0; margin: 0; line-height: 1; }
  #guestsbox { padding: 0.4333333em 0.9333333em 1.8333333em; position: relative; }
  #guestsbox:after { position: absolute; left: 50%; bottom: 0.83333em; content:" "; border-top: 20px solid #ddd; border-left: 20px solid transparent;border-right: 20px solid transparent;border-bottom: 0; margin-left: -10px; }
  #guestsbox ul { display: block; margin: 0 auto; padding: 0 0.63333333em; list-style: none; border: 4px solid #ddd; border-radius: 1em; position: relative; }
  #guestsbox img { max-width: 5em; }
  #guestsbox p { text-align: left; }
  #guestsbox ul li { display: block; border-top: 2px solid #efefef/* #fcac1f */; padding: 0.93333333em 0;  }
  #guestsbox ul li:first-child { border: 0; }
  .guest { display: flex; border: 0 solid red; align-content: center;  }
  .guest.comesnot { opacity: 0.4; }
  .guest_image_container { position: relative; z-index: 2; width: 5em; height: 5em; border: 4px solid #fdcb68; border-radius: 2.5em; overflow: hidden; background: #efefef url(../assets/img/kigebu-icon-cam-white.svg) center center no-repeat; background-size: 50%; }
  .guest_image_container img { display: block; position: relative;  }
  .guest_image { flex: 0 0 70%; text-align: center; padding: 0; margin: 0; position: relative; z-index: 1; }
  .guest_image .guest_name { position: absolute; z-index: 1; top: 0.43333em; left: 0.4444em; background: url(../assets/img/bg_guestname.svg) right center no-repeat; background-size: 14rem 2.8rem; width: auto; line-height: 2.83333rem; font-size: 1.4rem; color: #fff; text-align: left; padding: 0.1333em 2em 0 4em; white-space: nowrap; }
  .guest_image .guest_from { position: absolute; top: 3.43333em; left: 6.1333em; }
  .guest .forMe { }
  .guest_content { display: flex; flex-direction: row; align-items: center; }
  #sum_guests { background: #fdcb68; padding: 0.73333333em 0.73333333em 0.4333333em; border-radius: 10px; max-width: 16em; margin: 0 auto; color: #fff; font-weight: 700;}
</style>
